
import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import FeatureLabel from "../components/FeatureLabel";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger);


const AboutBYG = () => {
	const { t } = useTranslation();

	useEffect(() => {
        // Generic fade-in-up for all elements with .fade-in-up
        gsap.utils.toArray(".fade-in-up").forEach((el) => {
            gsap.fromTo(
                el,
                { y: 50, opacity: 0 },   // Start: slightly lower + invisible
                {
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: el,
                        start: "top 85%",   // When element enters viewport
                        toggleActions: "play none none reverse", // Animate in/out
                    },
                }
            );
        });
    }, []);

	const partnerCards = [
		{ bg: "#161B39", img: "icon1.png", header: t('aboutByg.card1Header'), text: t('aboutByg.card1Text') },
		{ bg: "#161B39", img: "icon2.png", header: t('aboutByg.card2Header'), text: t('aboutByg.card2Text') },
		{ bg: "#161B39", img: "icon1.png", header: t('aboutByg.card3Header'), text: t('aboutByg.card3Text') },
	];

	return (
		<>
			<div className="absolute inset-0 z-0 w-screen left-1/2 right-1/2 -mx-[50vw]">
				<img className="w-full" src={require("../media/images/StarSplash.png")} />
			</div>
			<div className='flex justify-center flex-col items-center mb-24 lg:min-h-[65vh]'>
				 <img
					className="mb-12 max-w-96"
					src={require("../media/images/BygSystems_FullLogo_Dark.png")}
					alt="BYG Systems Logo"
				/>
				<h1 className='text-4xl md:text-6xl text-[#101223] max-w-[600px] text-center leading-[1.125] fade-in-up'>
					{t('aboutByg.headlinePrefix')} <span className="text-[#4056F3]">{t('aboutByg.headlineHighlight1')}</span> {t('aboutByg.headlineMid')} <span className="text-[#4056F3]">{t('aboutByg.headlineHighlight2')}</span>
				</h1>

				<p className="text-[#4056F3] text-3xl font-semibold mt-10 tracking-tighter fade-in-up">{t('aboutByg.stat')}</p>
				<p className="font-semibold fade-in-up">{t('aboutByg.statLabel')}</p>

				<a
					href="https://www.bygsystems.com"
					target="_blank"
					rel="noopener noreferrer"
					className="mt-6 fade-in-up text-sm font-medium py-2 px-6 border border-[#4056F3] rounded-full text-[#4056F3] hover:bg-[#4056F3] hover:text-white transition-all duration-300 ease-in-out"
				>
					{t('aboutByg.visitSite')}
				</a>

			</div>

			<div className="bg-white rounded-3xl py-12 md:py-32 mb-24 xl:mb-72 z-10 relative">
				<div className="ml-responsive mr-responsive flex relative px-12 lg:px-0 items-center">
					{/* LEFT IMAGE */}
					<div className="w-[45%] relative hidden lg:block z-30">
						<img
							className="xl:absolute w-full xl:-top-48 right-0 fade-in-up"
							src={require("../media/images/person3.png")}
							alt=""
						/>
					</div>
					{/* RIGHT TEXT */}
					<div className="w-full lg:w-[55%] md:pl-12">
						<h2 className="fade-in-up text-2xl sm:text-5xl text-black sm:leading-tight">
							{t('aboutByg.heading2')}
						</h2>

						<p className="fade-in-up text-sm sm:text-base mt-6">
							{t('aboutByg.body')}
						</p>

					</div>
				</div>
			</div>

			<div className='mb-20'>
				<h2 className='text-4xl md:text-6xl text-black text-center leading-tight mb-16 fade-in-up'>
					{t('aboutByg.heading3')}
				</h2>

				<p className='text-center text-base mx-auto text-black mb-16 fade-in-up'>
					{t('aboutByg.partnerBody')}
				</p>

                <div className="flex flex-col justify-center relative mb-24">
                    <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-6 z-10 mx-auto w-full">
                        {partnerCards.map((card, index) => (
                            <div
                                key={index}
                                className="p-6 sm:p-8 rounded-xl flex-1 shadow leading-7 relative overflow-hidden
                                        transition-all duration-300 ease-in-out
                                        hover:scale-105 hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] fade-in-up"
                                style={{ backgroundColor: card.bg }}
                            >
                                {/* Gradient Overlay Effect */}
                                <div className="absolute inset-0 bg-white opacity-0 transition-opacity duration-300 hover:opacity-10"></div>

                                <img className="mb-4 relative z-10 w-10 sm:w-auto" src={require(`../media/images/${card.img}`)} alt={card.header} />
                                <h3 className="text-3xl mb-4">{card.header}</h3>
                                <p className="text-white text-base relative z-10">{card.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
        	</div>

			<div className="relative w-screen mb-24 overflow-hidden left-1/2 py-24 -translate-x-1/2 bg-[#4056F3]">
				<div className="max-w-screen-2xl mx-auto flex items-center gap-8 lg:gap-24 px-6 relative z-10  fade-in-up">
					<img className="w-40 lg:w-44 xl:w-44" src={require("../media/images/ISO-27001-2022-grey_no background1.png")} alt="ISO 27001 Certification" />
					<div>
						<h2 className="text-3xl lg:text-5xl text-white mb-4">{t('aboutByg.isoHeading')}</h2>
						<p className="text-white text-base lg:text-xl max-w-4xl">{t('aboutByg.isoBody')}</p>
					</div>
				</div>
       		</div>


		</>
	);
};

export default AboutBYG;
